import Record from "./record";

export default class GambleRecord extends Record {
    public collect: boolean;
}
